export default __webpack_public_path__ + "static/media/rocket_anim_120.e51010a3.png";